import { render, staticRenderFns } from "./VerifyDoctor.vue?vue&type=template&id=6a7e9109"
import script from "./VerifyDoctor.vue?vue&type=script&lang=js"
export * from "./VerifyDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports